import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Error500Service } from '../services/error-500.service';

@Component({
  selector: 'app-error-500-modal',
  standalone: true,
  imports: [CommonModule],
  template: `
    @if (isVisible) {
    <div class="modal-overlay">
      <div class="modal-content">
        <div class="error-icon">
          <i class="bi bi-exclamation-triangle"></i>
        </div>
        <h2>Error</h2>
        <p>
          Error inesperado. Por favor, intente nuevamente más tarde. Si el
          problema persiste, contacte a su administrador de cuentas.
        </p>
        <div class="button-container">
          <button
            class="btn-s-new"
            (click)="error500Service.redirectToContactos()"
          >
            Ir a contactos
          </button>
          <button
            class="btn-m-new"
            (click)="error500Service.hideError500Modal()"
          >
            Aceptar
          </button>
        </div>
      </div>
    </div>
    }
  `,
  styles: [
    `
      .modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        backdrop-filter: blur(10px);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1000;
      }

      .modal-content {
        background: white;
        padding: 2rem;
        border-radius: 12px;
        text-align: center;
        max-width: 400px;
        width: 90%;
      }

      .error-icon {
        color: #dc3545;
        font-size: 48px;
        margin-bottom: 1rem;
      }

      h2 {
        color: #004379;
        margin-bottom: 1rem;
      }

      p {
        color: #666;
        margin-bottom: 1.5rem;
      }

      .button-main {
        min-width: 120px;
      }

      .button-container {
        display: flex;
        justify-content: center;
        gap: 1rem;
      }
    `,
  ],
})
export class Error500ModalComponent {
  @Input() isVisible = false;

  constructor(public error500Service: Error500Service) {}
}
